// @flow
import type {DyCommonCartDataType, DyAddToCartDataType} from 'constants/flow/flowTypes';

import {floatPriceFromFormated} from 'libs/convertPrice/formatPrice';

type CartStateType = {
    quoteItems: Array<{
        product_id: number,
        qty: number,
        total: number,
        sku: string,
        frame: {
            frameSize: string,
        },
    }>,
    count: number,
    totals: {
        total: number,
    },
};

type StateType = {
    cart: CartStateType,
    customer: {
        currency: {code: string},
        is_subscribed: boolean,
    },
    storeInfo: {},
    quoteItems: {
        count: number,
        totals: {total: number},
        quoteItems: Array<{
            total: number,
            qty: number,
            product_sku: string,
            sku: string,
            frame: {frameSize: string},
        }>,
    },
};

/**
 * Get customer data is_subscribed
 * @param {StateType} state - customer state
 * @returns {boolean} - is customer subscribed
 */
export const isCustomerSubscribed = (state: StateType): boolean => state.customer.is_subscribed;

/**
 * Get Dynamic Yield Add Cart Data
 * @param {StateType} state - Application state
 * @returns {DyAddToCartDataType} - data
 */
export const getAddToCartData = (state: StateType): DyAddToCartDataType => {
    const {totals, quoteItems, count} = state.quoteItems;
    const lastItem = quoteItems[quoteItems.length - 1];
    return {
        value: floatPriceFromFormated(totals.total),
        currency: state.customer.currency.code,
        productId: lastItem.product_sku,
        quantity: count,
        size: (lastItem.frame && lastItem.frame.frameSize) || '',
        cart: quoteItems.map(product => ({
            productId: product.product_sku,
            quantity: product.qty,
            itemPrice: floatPriceFromFormated(product.total),
        })),
    };
};

/**
 * Get Dynamic Yield Sync Cart
 * @param {StateType} state - Application state
 * @returns {DyCommonCartDataType} - data
 */
export const getSyncCartData = (state: StateType): DyCommonCartDataType => {
    const {quoteItems} = state.quoteItems;

    return {
        currency: state.customer.currency.code,
        cart: quoteItems.map(product => ({
            productId: product.product_sku,
            quantity: product.qty,
            itemPrice: floatPriceFromFormated(product.total),
        })),
    };
};
